var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSun = function SvgIconSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-sun_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    clipPath: "url(#icon-sun_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.334 23.5a7.167 7.167 0 1 0 14.333 0 7.167 7.167 0 0 0-14.333 0ZM7.375 23.5h1.792M23.5 7.375v1.792M37.833 23.5h1.792M23.5 37.833v1.792M12.033 12.033l1.255 1.255m21.679-1.255-1.255 1.255m0 20.424 1.255 1.255m-21.68-1.255-1.254 1.255"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-sun_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-sun_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2 2h43v43H2z"
  })))));
};
export default SvgIconSun;